<template>
	<div :class="measureOuterClasses()" v-on:click="previewMeasure">
		<!-- @vue-expect-error -->
		<div
			v-if="measure.ex_machina_phase_index"
			:style='{ width: "100%", height: "200px", overflow: "hidden", textAlign: "center" }'
		>
			<!-- @vue-expect-error -->
			<img
				:src="`/img/unionslabor/external_events/event_phase_${measure.ex_machina_phase_index}.jpg`"
				style="width: 100%;"
			>
		</div>
		<!-- @vue-expect-error -->
		<div v-if="!measure.is_national_measure" class="measureEffects">
			<div
				v-if="groupedModEffects"
				v-for="key in Object.keys(groupedModEffects)"
				:key="key"
				:class="`measureEffects-modifier-group modifiers-of-${key}`"
			>
				<div class="measureEffects-property">
					<img :src="`/img/unionslabor/icons/${key}_white.svg`">
				</div>
				<div class="measureEffects-group">
					<div
						:class="measureModSegmentClasses(mod)"
						v-if='!groupedModEffects[key][0].applicability_conditions.includes("all_actors")'
						v-for="mod in groupedModEffects[key]"
						:style='{ width: (100 / groupedModEffects[key].length) + "%" }'
						:key="mod.id"
					>
						<div class="measureEffects-actorEffect-modifierCondition">
							{{ conditionsToString(mod.applicability_conditions) }}
						</div>
						<div class="measureEffects-actorEffect-actors">
							<div
								v-for="mod_effect in mod.modifiers_per_actor"
								:key="mod_effect.actor.id"
							>
								<img :src="`/img/flags/${mod_effect.actor.name}.svg`">
							</div>
						</div>
						<div class="measureEffects-actorEffect-value">
							{{ modifierEffectString(mod.modifiers_per_actor[0], mod) }}
						</div>
					</div>
					<div
						:class="measureModSegmentClasses(lastRankedModSegments()[idx])"
						v-if='groupedModEffects[key][0].applicability_conditions.includes("all_actors")'
						v-for="(mod, idx) in lastRankedModSegments()"
						:key='mod.id + "-all-actors"'
						:style='{ width: (100 / lastRankedModSegments().length) + "%" }'
					>
						<div class="measureEffects-actorEffect-actors">
							<div
								v-for="mod_effect in mod.modifiers_per_actor"
								:key="mod_effect.actor.id"
							>
								<img :src="`/img/flags/${mod_effect.actor.name}.svg`">
							</div>
						</div>
						<div class="measureEffects-actorEffect-value">
							{{
								groupedModEffects[key][0].static_modifying_range[0] > 0
									? "+"
									: ""
							}}
							{{ groupedModEffects[key][0].static_modifying_range[0] }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="measure-inner">
			<div class="measureEffectsProps">
				<div
					v-if="(spendableModifier && spendableModifier.static_modifying_range[1] <= 0)"
					:style='{ width: "24px", height: 100 / effectsProperties(measure).length + "%" }'
					v-for="type_key in effectsProperties(measure)"
					:key="type_key"
					:class="`measureEffectsProp ${type_key}`"
				>
					<img :src="`/img/unionslabor/icons/${type_key}_white.svg`">
				</div>
				<div
					v-if="spendableModifier && spendableModifier.static_modifying_range[1] > 0"
					:style='{ width: "24px", height: 100 + "%" }'
					class="measureEffectsProp action_points"
				>
					<strong>{{ spendableModifier.static_modifying_range[0] }}</strong>
					<strong>
						<img
							style="width: 14px;"
							class="small-coin"
							src="/img/unionslabor/icons/starcoin.svg"
						>
					</strong>
				</div>
			</div>
			<div class="measure-content">
				<div class="measure-content-header clearfix">
					<!-- @vue-expect-error -->
					<div v-if="measure.is_new" class="new-icon">Neu</div>
					<!-- @vue-expect-error -->
					<span
						v-if="previewingMeasure && previewingMeasure.id === measure.id"
						class="preview-text"
						>{{
							t("global.preview").toUpperCase()
						}}</span
					>
					<!-- @vue-expect-error -->
					<div
						v-if="!measure.is_national_measure"
						class="measure-cost-proposable"
					>
						<h2>{{ t("global.cost").toUpperCase() }}</h2>
						<span
							v-if="spendableModifier.calculates_percentage"
							style="color: #e55a71;"
							>jede Runde {{ spendableModifier.static_modifying_range[1] }}%
							AP</span
						>
						<div
							class="cost"
							v-if="!spendableModifier.calculates_percentage && spendableModifier.static_modifying_range[1] < 0"
						>
							<div class="cost-value">
								{{ Math.abs(spendableModifier.static_modifying_range[1]) }}
								<span style="color: #667690; font-weight: normal;"
									>/ {{ currentSpendableValue }}</span
								>
								<img
									class="small-coin"
									src="/img/unionslabor/icons/starcoin.svg"
								>
							</div>
						</div>
						<div
							class="cost"
							v-if="!spendableModifier.calculates_percentage && spendableModifier.static_modifying_range[1] > 0"
						>
							<div
								class="cost-value"
								v-for="modifier in effectsNegativeModifiers(measure)"
								:key='"neg-" + modifier.id'
							>
								{{ modifier.static_modifying_range[0] }}
								<img
									:src="`/img/unionslabor/icons/${modifier.property.type_key}.svg`"
								>
							</div>
						</div>
					</div>
				</div>
				<div v-if="postDecidedTimeoutIsFinished" class="measure-text">
					<h2 class="measure-title">
						<span>Folgen</span>
					</h2>
					<!-- @vue-expect-error -->
					<p
						v-if='measure.latest_draft_state == "passed" && measure.enacted_descriptions[locale]'
						class="result-text"
						v-html="measure.enacted_descriptions[locale]"
					></p>
					<!-- @vue-expect-error -->
					<p
						v-if='measure.latest_draft_state == "failed" && measure.failed_descriptions[locale]'
						class="result-text"
						v-html="measure.failed_descriptions[locale]"
					></p>
				</div>
				<div v-if="!postDecidedTimeoutIsFinished" class="measure-text">
					<h2 class="measure-title">
						<span> <!-- @vue-expect-error --> {{ measure.names[locale] }}</span>
					</h2>
					<!-- @vue-expect-error -->
					<p
						class="measure-description"
						v-if='measure.descriptions[locale] != ""'
						v-html="measure.descriptions[locale]"
					></p>
				</div>
			</div>
			<!-- @vue-expect-error -->
			<div
				v-if="spendableModifier && measure.is_national_measure"
				class="measure-cost"
			>
				<h2>{{ t("global.cost").toUpperCase() }}:</h2>
				<span
					v-if="spendableModifier.calculates_percentage"
					style="color: #e55a71;"
					>jede Runde {{ spendableModifier.static_modifying_range[1] }}%
					AP</span
				>
				<div
					class="cost"
					v-if="!spendableModifier.calculates_percentage && spendableModifier.static_modifying_range[1] < 0"
				>
					<div class="cost-value">
						{{ Math.abs(spendableModifier.static_modifying_range[1]) }}
						<img class="small-coin" src="/img/unionslabor/icons/starcoin.svg">
					</div>
				</div>
				<div
					class="cost"
					v-if="!spendableModifier.calculates_percentage && spendableModifier.static_modifying_range[1] > 0"
				>
					<div
						class="cost-value"
						v-for="modifier in effectsNegativeModifiers(measure)"
						:key='"neg-" + modifier.id'
					>
						{{ Math.abs(modifier.static_modifying_range[0]) }}
						<img
							class="colored-property-icon"
							:src="`/img/unionslabor/icons/${modifier.property.type_key}.svg`"
						>
						<!-- @vue-expect-error -->
						<img
							v-if="previewingMeasure && previewingMeasure.id === measure.id"
							:src="`/img/unionslabor/icons/${modifier.property.type_key}_white.svg`"
						>
					</div>
				</div>
			</div>
		</div>
		<!-- @vue-expect-error -->
		<div
			v-if="!postDecidedTimeoutIsFinished && !measure.is_national_measure"
			class="measure-type-icons"
		>
			<!-- @vue-expect-error -->
			<div v-if="measure.has_impacts" class="voting-impact-icon type-icon">
				<img :src="`/img/unionslabor/icons/voting-impact.svg`">
				Achtung:
				<br>
				Du kannst danach überstimmt werden.
			</div>
			<div v-if="containsReocurringModifiers" class="reocurring-icon type-icon">
				<img :src="`/img/unionslabor/icons/reocurring.svg`">
				EU-Meilenstein!
				<br>
				Effekte wirken jede Runde erneut.
			</div>
			<!-- @vue-expect-error -->
			<div
				v-if="measure.closes_measures_names.length"
				class="either-or-icon type-icon"
			>
				<img :src="`/img/unionslabor/icons/either-or.svg`">
				<!-- @vue-expect-error -->
				Schließt das Gesetz „{{ measure.closes_measures_names[0][locale] }}“
				aus.
			</div>
		</div>
	</div>
</template>

<script>
// Other components
import Modifier from "../modifiers_components/modifier.vue";
import { i18n } from "../utils";

export default {
	// Naming - server = srv
	name: "measure-node",
	mixins: [i18n],
	props: {
		measure: Object,
		draft: Object,
		postDecidedTimeoutIsFinished: Boolean,
		isSelectable: Boolean,
		srvPhaseId: Number,
	},
	components: {
		modifier: Modifier,
	},
	data: function () {
		return {
			state: "",
		};
	},
	computed: {
		phaseId: function () {
			return this.srvPhaseId !== undefined
				? this.srvPhaseId
				: pp.gameState.phaseId;
		},
		groupedModEffects: function () {
			// @ts-expect-error
			if (!this.measure.modifiers_by_actor) {
				return {};
			}
			return this.groupBy(
				// @ts-expect-error
				this.measure.modifiers_by_actor.filter((mod) => {
					return mod.property.type_key != "action_points";
				}),
				"property.type_key",
			);
		},
		currentSpendableValue: function () {
			const spendableAp = VueStore.getters.actorPropertyOfTypeFor(
				pp.currentActorId,
				"action_points",
			);
			return Math.floor(spendableAp.values[this.phaseId].current_value);
		},
		containsReocurringModifiers: function () {
			// @ts-expect-error
			if (!this.measure.modifiers) {
				return false;
			}

			return (
				// @ts-expect-error
				this.measure.modifiers.find((mod) => mod.phase_lifecycle >= 5) !=
				undefined
			);
		},
		previewingMeasure: function () {
			return VueStore.getters.previewingMeasure();
		},
		spendableModifier: function () {
			// @ts-expect-error
			return this.measure.modifiers.find(
				(mod) => mod.property.type_key == "action_points",
			);
		},
		locale: function () {
			return I18n.locale;
		},
	},
	mounted() {},
	beforeDestroy() {},
	methods: {
		groupBy(array, key) {
			const splitKey = key.split(".");
			return array.reduce(function (rv, x) {
				(rv[x["property"]["type_key"]] =
					rv[x["property"]["type_key"]] || []).push(x);
				return rv;
			}, {});
		},
		measureOuterClasses() {
			let classes = ["measure-outer", "animated", "fadeInUp"];
			const articleIdOfMeasure =
				// @ts-expect-error
				this.measure.article_ids_per_actor[pp.currentActorId] ||
				// @ts-expect-error
				this.measure.article_ids_per_actor[
					VueStore.getters.actorData(pp.currentActorId).principalGroupId
				];
			const isEnactableForActor =
				// @ts-expect-error
				this.measure.is_enactable_per_article[articleIdOfMeasure];
			classes.push(
				// @ts-expect-error
				this.measure.modifiers
					.map((mod) => {
						return `modifiers-of-${mod.property.type_key}`;
					})
					.filter((v, i, a) => a.indexOf(v) === i)
					.join(" "), // If there are more than one we don't want to push an array into an array.
			);
			if (this.containsReocurringModifiers) {
				classes.push("reocurring-effects");
			}
			if (
				this.previewingMeasure &&
				// @ts-expect-error
				this.measure.id === this.previewingMeasure.id
			) {
				classes.push("measure-previewing");
			}
			classes.push(
				// @ts-expect-error
				this.measure.is_national_measure ? "choosable" : "proposable",
			);
			classes.push(isEnactableForActor ? "enactable" : "not-enactable");
			if (this.state == "clicked") {
				classes.push("measure-clicked");
			}
			if (
				// @ts-expect-error
				_.intersection(this.measure.enacted_by_actors, [
					pp.currentActorId,
					VueStore.getters.actorData(pp.currentActorId).principalGroupId,
				]).length
			) {
				classes.push("passed");
			}
			return classes.join(" ");
		},
		latestAppValFor(actorId, property) {
			const actorAp = VueStore.getters
				.actorsPropertiesFor(actorId)
				.find((app) => app.property.type_key === property.type_key);
			if (actorAp) {
				return actorAp.values[this.phaseId].current_value;
			}
			return 0;
		},
		filterModifiersByProperty(modifiers, property) {
			return modifiers.filter((m) => m.property.type_key === property.type_key);
		},
		calculateModifierEffectFor(modEffect, modifier) {
			if (modEffect.calculated_effect) {
				return modEffect.calculated_effect;
			}
			if (modifier.calculates_percentage) {
				const rangeToFloat = modifier.static_modifying_range[1] / 100;
				const latestAppVal = this.latestAppValFor(
					modEffect.actor.id,
					modifier.property,
				);
				return latestAppVal + latestAppVal * rangeToFloat;
			}
			// else
			return modifier.static_modifying_range[1];
		},
		modifierEffectString(mod_pers_actor, mod) {
			const val = Math.floor(
				this.calculateModifierEffectFor(mod_pers_actor, mod),
			);
			return val > 0 ? `＋${val.toString()}` : `- ${Math.abs(val)}`;
		},
		previewMeasure(e) {
			if (!this.isSelectable) {
				return false;
			}
			e.preventDefault();
			e.stopPropagation();
			if (this.draft) {
				pp.log("Draft for this Measure exists!");
				return false;
			}
			VueStore.commit("updatePreviewingMeasure", {
				measure:
					// @ts-expect-error
					this.previewingMeasure && this.previewingMeasure.id == this.measure.id
						? null
						: this.measure,
			});
		},

		conditionsToString(applicabilityConditions) {
			let conditionStrings = [];
			let thisConditionData;
			applicabilityConditions.forEach((conditionData) => {
				thisConditionData = conditionData;
				if (typeof thisConditionData === "object") {
					const conditionKey = Object.keys(thisConditionData)[0];
					const conditionValues = Object.values(thisConditionData)[0];
					if (conditionKey == "top_in_property") {
						conditionValues.forEach((rank) => {
							conditionStrings.push(`Platz ${rank}`);
						});
					} else if (conditionKey == "bottom_in_property") {
						conditionValues.forEach((rank) => {
							conditionStrings.push(`Platz ${6 - rank}`);
						});
					} else {
						// should never happen here
						conditionStrings.push(`${conditionKey}: ${conditionValues}`);
					}
				} else {
					// should never happen here
					conditionStrings.push(thisConditionData);
				}
			});
			return conditionStrings.join(", ");
		},
		totalMeasureModifierEffect(measure) {
			return measure.modifiers
				.filter((mod) => mod.property.type_key != "action_points")
				.map((mod) => mod.static_modifying_range[1])
				.reduce((a, b) => {
					return a + b;
				}, 0);
		},
		effectsProperties(measure) {
			return measure.modifiers
				.filter((mod) => mod.property.type_key != "action_points")
				.map((mod) => mod.property.type_key)
				.filter((v, i, a) => a.indexOf(v) === i); //uniq
		},
		effectsNegativeModifiers(measure) {
			return measure.modifiers.filter(
				(mod) =>
					mod.property.type_key != "action_points" &&
					mod.static_modifying_range[0] < 0,
			);
		},
		lastRankedModSegments() {
			let rankedModifiers = null;
			const typeKeysOfModifiers = Object.keys(this.groupedModEffects);
			// Default to the first Modifier even if it's for 'all_actors' if it is the only present one
			if (typeKeysOfModifiers.length == 1) {
				// @ts-expect-error
				rankedModifiers = this.groupedModEffects[typeKeysOfModifiers[0]];
			}
			typeKeysOfModifiers.forEach((key) => {
				if (
					!this.groupedModEffects[key][0].applicability_conditions.includes(
						"all_actors",
					)
				) {
					rankedModifiers = this.groupedModEffects[key];
				}
			});
			// if (rankedModifiers == null) {
			// 	pp.log("no ranked modifiers!", this.measure);
			// }
			return rankedModifiers;
		},
		measureModSegmentClasses(mod) {
			let classes = "measureEffects-actorEffect";
			if (
				!mod.applicability_conditions.includes("all_actors") &&
				mod.modifiers_per_actor
					.map((m) => m.actor.id)
					.includes(pp.currentActorId)
			) {
				classes += " own-actor";
			}
			return classes;
		},
	},
};
</script>
